const isCancelledRequest = error => error?.code === "ERR_CANCELED";

const requestData = async (request, { errorMessage, quietCancellation = false } = {}) => {
  try {
    const response = await request;
    return response?.data;
  } catch (error) {
    if (errorMessage && (!quietCancellation || !isCancelledRequest(error))) {
      console.error(errorMessage, error);
    }
    throw error;
  }
};

export { isCancelledRequest, requestData };
